var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
// Requires: LayerGroupLayer
OCS.Viewer.Functions.define_layer_group_layer_manipulation_interface = function () {
    OCS.Viewer.Interfaces.LayerGroupLayerManipulation = {
        layers: {},
        layer_class_obj: null,
        active_layer: null, // A pointer of sorts to the earliest created layer
        init_layer_manipulation_events: function () {
            this.addEvent('destroy_layer_group', this.destroy_layer_manipulation.bind(this));
            this.addEvent('add_layer', this.on_add_layer_manipulation.bind(this));
            this.addEvent('remove_layer', this.on_remove_layer_manipulation.bind(this));
            this.addEvent('refresh_layer_style', this.on_refresh_layer_style.bind(this));
        },
        get_layers: function () {
            return this.layers;
        },
        // Retrieve a layer based on its id
        get_layer_with_id: function (layer_id) {
            if (layer_id in this.layers) {
                return this.layers[layer_id];
            } else {
                return false;
            }
        },

        remove_all_layers: function () {
            this.fireEvent('deactivate_layer');
            Object.each(this.layers, function (layer) {
                this.fireEvent('remove_layer', layer);
            }.bind(this));
        },
        // Event Listeners
        on_add_layer_manipulation: function (layer_obj) {
            if (layer_obj) {
                // Add the layer instance to our stored list of layers
                this.layers[layer_obj.get_id()] = layer_obj;
            }
        },
        on_refresh_layer_style: function () {
            Object.each(this.layers, function (layer) {
                layer.refresh_style();
            }.bind(this));
        },
        on_remove_layer_manipulation: function (layer) {
            var layer_id = layer.get_id();
            if (layer_id in this.layers) {
                this.layers[layer_id] = {};
                // delete the object itself
                delete this.layers[layer_id];
            }
        },
        destroy_layer_manipulation: function () {
            this.remove_all_layers();
        }
    };
};
OCS.Viewer.Functions.define_layer_group_layer_manipulation_interface();